export default "__VITE_ASSET__d4f1de91__"